import React, { useEffect, useState } from "react";
import {
  Col,
  Row,
  Select,
  Button,
  DatePicker,
  Form,
  InputNumber,
  Switch,
  Card,
  Spin,
  Tooltip,
} from "antd";
import { useTranslation } from "react-i18next";
import { noWhitespace } from "../../../../../utils/rules";
import { notify } from "../../../../../redux/actions";
import aictia from "../../../../../const/api";
import moment from "moment";
import { connect } from "react-redux";
import { PlusOutlined, MinusOutlined } from "@ant-design/icons";
import {
  SearchOutlined,
  LoadingOutlined,
} from "@ant-design/icons";
import { InputText } from 'primereact/inputtext';
import { FloatLabel } from "primereact/floatlabel";
import { useHistory } from "react-router-dom";
const { Option } = Select;

function Innovation(props) {
  const { t } = useTranslation();
  const [form] = Form.useForm();
  const mainUrl = "Innovation";
  const history = useHistory();
  const [fieldOfUse, setFieldOfUse] = useState([]);
  const [typeOfInnovation, setTypeOfInnovation] = useState([]);
  const [categories, setCategories] = useState([]);
  const [subCategories, setSubCategories] = useState([]);
  const [categoriesType, setCategoriesType] = useState([]);
  const [subDisable, setSubDisable] = useState(true);
  const [typeDisable, setTypeDisable] = useState(true);
  const [spin, setSpin] = useState(false);
  const [editing, setEditing] = useState(null);
  const [field, setField] = useState([]);
  const [innovationCate, setInnovationCate] = useState([]);
  const [techArray, setTechArray] = useState([0]);

  const [isInnovationCer, setIsInnovationCer] = useState(false);
  const [isPatent, setIsPatent] = useState(false);

  const [searchTinCompany, setSearchTinCompany] = useState("");
  const [searchCompanyData, setSearchCompanyData] = useState([]);
  const [showSuggestions, setShowSuggestions] = useState(false);
  const [companyId, setCompanyId] = useState(null);
  const [loading, setLoading] = useState(false);
  const [disable, setDisable] = useState(false);
  // props
  const { notify } = props;

  useEffect(() => {
    const fetchData = async () => {
      try {
        // Fetch Field of Use
        const fieldRes = await aictia.get("UsageArea");
        setFieldOfUse(fieldRes.data);

        // Fetch Type of Project
        const typeRes = await aictia.get("TypeOfInnovation");
        setTypeOfInnovation(typeRes.data);

        // Fetch Categories
        const categoryRes = await aictia.get("TechnologyFilter/TechnologyFields");
        const fetchedCategories = categoryRes.data.technologyCagegory || [];
        setCategories(fetchedCategories);

        // If editing existing innovation
        if (props.id) {
          setEditing(true);
          if (props.view) {
            setDisable(true);
          }

          const innovationRes = await aictia.get(`${mainUrl}/${props.id}`);
          const innovation = innovationRes.data;

          form.setFieldsValue({
            ...innovation,
            startDate: innovation.startDate ? moment(innovation.startDate) : null,
            endDate: innovation.endDate ? moment(innovation.endDate) : null,
            usageAreaId: innovation.innovationUsageAreas.map(item => item.usageAreaId),
          });
          setIsInnovationCer(innovation.certificate);
          setIsPatent(innovation.patent);
          setSubDisable(false);
          setTypeDisable(false);
          setField(innovation.innovationUsageAreas);
          setCompanyId(innovation.reyestrOfCompanyId);
          setInnovationCate(innovation.innovationCategories);

          const techArray1 = [];
          const subCategoriesModify = [];
          const categoriesTypeModify = [];

          if (innovation.innovationCategories.length > 0 && fetchedCategories.length > 0) {
            innovation.innovationCategories.forEach((item, index) => {
              techArray1.push(index);

              // Find matching category
              const matchedCategory = fetchedCategories.find(
                (cat) => cat.id === item.technologyCategoryId
              );

              if (matchedCategory) {
                const subCate = matchedCategory.technologySubCagegory || [];
                subCategoriesModify.push({ index, array: subCate });

                const matchedSub = subCate.find(
                  (sub) => sub.id === item.technologySubcategoryId
                );
                const type = matchedSub?.technologyType || [];

                categoriesTypeModify.push({ index, array: type });
              }
            });
          } else {
            techArray1.push(0);
            setSubDisable(true);
            setTypeDisable(true);
          }

          setSubCategories(subCategoriesModify);
          setCategoriesType(categoriesTypeModify);
          setTechArray(techArray1);
        }

      } catch (error) {
        console.error("Data fetching error:", error);
      }
    };

    fetchData();
  }, [t])

  //subcate
  const getSubcategories = (value, index) => {
    let cate = subCategories;

    cate = cate.filter((elem) => elem.index !== index);

    const subCate = categories.find(
      (item) => item.id === value
    ).technologySubCagegory;
    setSubCategories([...cate, { index: index, array: subCate }]);

    setSubDisable(false);
    form.resetFields([
      ["innovationCategories", index, "technologySubcategoryId"],
    ]);
    form.resetFields([["innovationCategories", index, "technologyTypeId"]]);
  };

  //type
  const getCategoriesType = (value, index) => {
    let cateType = categoriesType;
    cateType = cateType.filter((item) => item.index !== index);
    const data = subCategories.find((item) => item.index === index).array;
    const type = data.find((item) => item.id === value).technologyType;

    setCategoriesType([...cateType, { index: index, array: type }]);

    setTypeDisable(false);
    form.resetFields([["innovationCategories", index, "technologyTypeId"]]);
  };


  const checkTinCompany = async () => {
    setLoading(true);
    const searchTinCompany = form.getFieldValue("searchTinCompany");
    aictia.get(`Portfolio/FindReyestrOfCompany?keyword=${searchTinCompany}`).then((res) => {
      if (res.data.length == 1) {
        form.setFieldsValue({
          subjectName: res.data[0].name,
          searchTinCompany: res.data[0].tin
        })
        setSearchTinCompany(res.data[0].tin);

        setCompanyId(res.data[0].id);
        setShowSuggestions(false);
        setSearchCompanyData([]);
      }
      else if (res.data.length > 1) {
        setSearchCompanyData(res.data);
      }
      else {
        setSearchCompanyData([]);
        form.setFieldsValue({
          subjectName: "",
        })
        form.setFields([
          {
            name: 'searchTinCompany',
            errors: ['Bu VÖEN tapılmadı'],
          },
        ]);
        setCompanyId(null);
      }
    })
      .catch((err) => {
        setLoading(false);
        notify(err.response, false);
      }
      ).finally(() => {
        setLoading(false)
      });
  }

  const cancelEditing = () => {
    setEditing(null);
    setTechArray([0]);
    setIsInnovationCer(false);
    setIsPatent(false);
    form.resetFields();
    history.push("/portfolio");

  };
  const save = async (values) => {
    const data = {
      ...values,
      reyestrOfCompanyId: companyId,
      certificate: isInnovationCer,
      patent: isPatent,
      // innovationCategories: values?.innovationCategories[0].technologyCategoryId ? values?.innovationCategories : [],
      innovationCategories: values.innovationCategories.filter(
        (innovation) => innovation?.technologyCategoryId),
      innovationUsageAreas: values?.usageAreaId ? values?.usageAreaId.map((item) => {
        return {
          usageAreaId: item,
        };
      }) : [],
    };

    if (!editing) {
      await aictia
        .post(mainUrl, data)
        .then((res) => {
          notify("", true);
          cancelEditing();
        })
        .catch((err) => {
          notify(err.response, false);
        });
    } else {
      //field
      const id = Number(props.id);

      const dataUsageAreaIds = data.innovationUsageAreas.map(
        (item) => item.usageAreaId
      );
      const updateFieldsIds = field.map((elem) => elem.usageAreaId);
      const updatedField = field.map((item) => {
        const isActive = dataUsageAreaIds.includes(item.usageAreaId);
        return { ...item, isActive };
      });

      data.innovationUsageAreas.map((elem) => {
        elem.isActive = true;
      });
      data.innovationUsageAreas = data?.innovationUsageAreas.filter(
        (elem) => !updateFieldsIds.includes(elem.usageAreaId)
      );
      data.innovationUsageAreas.push(...updatedField);

      //cate
      const modifyData = data?.innovationCategories.filter(item => item !== undefined)
      const innovationCategoryIds = modifyData.map(
        (item) => item.id
      );

      const updatedInnovationCate = innovationCate.map((item) => {
        const isActive = innovationCategoryIds.includes(item.id);
        return { ...item, isActive };
      });

      const filteredModifyData = modifyData.filter((elem) => {
        if (elem.technologyCategoryId === undefined) {
          return false;
        }
        elem.isActive = true;
        return true;
      });
      filteredModifyData.push(
        ...updatedInnovationCate.filter((elem) => elem.isActive === false && elem.technologyCategoryId)
      );

      data.innovationCategories = filteredModifyData
      await aictia
        .put(`${mainUrl}/${id}`, { ...data, id: id })
        .then((res) => {
          notify("", true);
          cancelEditing();
        })
        .catch((err) => {
          notify(err.response, false);
        });
    }
  };

  const handleDeleteRow = (element) => {
    if (techArray.length > 1) {
      setTechArray(techArray.filter((elem) => elem !== element));
      form.resetFields([
        ["innovationCategories", element, "technologyCategoryId"],
      ]);
      form.resetFields([
        [["innovationCategories", element, "technologySubcategoryId"]],
      ]);
      form.resetFields([
        [["innovationCategories", element, "technologyTypeId"]],
      ]);
    }
  };
  const antIcon = (
    <LoadingOutlined
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
      spin
    />
  );
  return (
    <div>

      <Form layout="vertical" onFinish={save} form={form}>
        <div className={`commontask taskkk` + (props.view ? " detail" : "")}>
          <Card>
            <Row gutter={[16, 32]}>
              {
                !props.id && !props.view &&
                <Col md={6} sm={12} xs={24}>
                  <FloatLabel>
                    {
                      <Form.Item
                        name="searchTinCompany"
                        validateTrigger="onChange"
                      >
                        <div className="searchInput" style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>

                          <InputText style={{borderRadius: "12px"}} disabled={props.id ? true : false} size={"large"} className='w-full' id="searchTinCompany" value={searchTinCompany}

                            onChange={(e) => {
                              setSearchTinCompany(e.target.value);
                              form.setFieldsValue({ searchTinCompany: e.target.value });
                              setShowSuggestions(true);
                            }}
                          />
                          {
                            !props.view && !props.id && (loading ? <Spin indicator={antIcon} className="searchTin" /> : <SearchOutlined onClick={checkTinCompany}
                              className="searchTin" />)
                          }

                        </div>

                        {showSuggestions && searchCompanyData.length > 1 && (
                          <ul
                            style={{
                              position: 'absolute',
                              top: '100%',
                              left: 0,
                              right: 0,
                              backgroundColor: 'white',
                              border: '1px solid #ccc',
                              zIndex: 999,
                              maxHeight: 200,
                              overflowY: 'auto',
                              margin: 0,
                              padding: 0,
                              listStyle: 'none'
                            }}
                          >
                            {searchCompanyData.map(item => (
                              <li
                                key={item.id}
                                style={{ padding: '10px', cursor: 'pointer', borderBottom: '1px solid #eee' }}
                                onClick={() => {
                                  form.setFieldsValue({
                                    subjectName: item.name,
                                    searchTinCompany: item.tin
                                  });
                                  setCompanyId(item.id);
                                  setSearchTinCompany(item.tin);
                                  setShowSuggestions(false);
                                }}
                              >
                                {item.name}
                              </li>
                            ))}
                          </ul>
                        )}
                      </Form.Item>
                    }
                    <label htmlFor="searchTinCompany">{t('search')}</label>
                  </FloatLabel>
                </Col>
              }
              {
                !props.id && !props.view &&
                <Col md={6} sm={12} xs={24}>
                  <FloatLabel>
                    <Form.Item

                      name="subjectName"
                      validateTrigger="onChange"
                      rules={[noWhitespace(t("inputError"))]}

                    >
                      <InputText style={{borderRadius: "12px"}} size={"large"} className="w-full" id="subjectName" disabled={true} />
                    </Form.Item>
                    <label htmlFor="subjectName">{t("Subyektin  adı ")}<span style={{ color: 'red' }}>*</span></label>

                  </FloatLabel>

                </Col>
              }
              <Col md={6} sm={12} xs={24}>
                <FloatLabel>
                  <Form.Item
                    name="innovationName"
                    validateTrigger="onChange"
                    rules={[noWhitespace(t("inputError"))]}
                  >
                    <InputText style={{borderRadius: "12px"}} size={"large"} className="w-full" id="innovationName" disabled={disable} />
                  </Form.Item>
                  <label htmlFor="innovationName">{t("İnnovasiyanın adı ")} <span style={{ color: 'red' }}> *</span></label>
                </FloatLabel>
              </Col>
              <Col md={6} sm={12} xs={24}>
                <FloatLabel>
                  <Form.Item
                    name="inventor"
                    validateTrigger="onChange"
                  >
                    <InputText style={{borderRadius: "12px"}} size={"large"} className="w-full" id="inventor" disabled={disable} />
                  </Form.Item>
                  <label htmlFor="inventor">{t("İcad edən şəxs ")}</label>
                </FloatLabel>
              </Col>
              <Col md={6} sm={12} xs={24}>
                <FloatLabel>
                  <Form.Item
                    name="startDate"
                    validateTrigger="onChange"
                  >
                    <DatePicker style={{borderRadius: "12px"}} placeholder={t("Tarixi seçin")} className="w-100" disabled={disable} />
                  </Form.Item>
                  <label htmlFor="startDate">{t("Başlama tarixi")}</label>
                </FloatLabel>
              </Col>
              <Col md={6} sm={12} xs={24}>
                <FloatLabel>
                  <Form.Item
                    name="endDate"
                    validateTrigger="onChange"
                  >
                    <DatePicker style={{borderRadius: "12px"}} placeholder={t("Tarixi seçin")} className="w-100" disabled={disable} />
                  </Form.Item>
                  <label htmlFor="endDate">{t("Bazara giriş tarixi")}</label>
                </FloatLabel>
              </Col>

              <Col md={6} sm={12} xs={24}>
                <FloatLabel>
                  <Form.Item
                    name="usageAreaId"
                    validateTrigger="onChange"
                  //   rules={[whiteSpace(t("inputError"))]}
                  >
                    <Select className="custom-select"
                      id="usageAreaId"
                      mode="multiple"
                      maxTagCount={1}
                      filterOption={(input, option) =>
                        option.children
                          .toLowerCase()
                          .indexOf(input.toLowerCase()) >= 0
                      }
                      maxTagPlaceholder={(omittedValues) => (
                        <Tooltip title={omittedValues.map(i => i.label).join(", ")}>
                          <span>+{omittedValues.length}</span>
                        </Tooltip>
                      )}
                      disabled={disable}
                    >
                      {fieldOfUse.map((p, index) => {
                        return (
                          <Option key={index} value={p.id}>
                            {p.name}
                          </Option>
                        );
                      })}
                    </Select>

                  </Form.Item>
                  <label htmlFor="usageAreaId">{t("İstifadə sahəsi")}</label>
                </FloatLabel>
              </Col>

              <Col md={6} sm={12} xs={24}>
                <FloatLabel>
                  <Form.Item
                    name="typeOfInnovationId"
                    validateTrigger="onChange"
                    rules={[noWhitespace(t("inputError"))]}

                  >
                    <Select disabled={disable} className="custom-select">
                      {typeOfInnovation.map((p, index) => {
                        return (
                          <Option key={index} value={p.id}>
                            {p.name}
                          </Option>
                        );
                      })}
                    </Select>
                  </Form.Item>
                  <label htmlFor="typeOfInnovationId">{t("İnnovasiyanın növü")}<span style={{ color: 'red' }}> *</span></label>
                </FloatLabel>
              </Col>

              <Col md={6} sm={12} xs={24}>
                <FloatLabel>
                  <div className="form-lang">

                    <Form.Item
                      name="budget"
                      validateTrigger="onChange"
                    >
                      <InputNumber style={{borderRadius: "12px"}} id="budget" defaultValue={0} className="w-full" size={"large"} readOnly={disable} />
                    </Form.Item>
                    <div className="input-lang">azn</div>
                  </div>
                  <label htmlFor="budget">{t("Büdcə")}</label>
                </FloatLabel>
              </Col>
              <Col md={6} sm={12} xs={24}>
                <FloatLabel>

                  <Form.Item
                    name="webPageUrl"
                    validateTrigger="onChange"
                  >
                    <InputText style={{borderRadius: "12px"}} size={"large"} className="w-full" id="webPageUrl" disabled={disable} />
                  </Form.Item>
                  <label htmlFor="webPageUrl">{t("Web səhifə")}</label>
                </FloatLabel>
              </Col>
              <Col md={6} sm={12} xs={24}>
                <div className="flex mb-15" style={{borderRadius: "12px"}}>
                  <Switch
                    className={"mr-15"}
                    checked={isInnovationCer}
                    onChange={() => {
                      setIsInnovationCer(!isInnovationCer);
                    }}
                    disabled={disable}
                  />
                  <span className="mr-15"> İnnovasiya sertifikatı</span>
                  <span className={isInnovationCer ? "green" : "red"}>
                    {isInnovationCer ? "+" : "-"}
                  </span>
                </div>
                <div className="flex mb-15" style={{borderRadius: "12px"}}>
                  <Switch
                    className={"mr-15"}
                    checked={isPatent}
                    onChange={() => {
                      setIsPatent(!isPatent);
                    }}
                    disabled={disable}
                  />
                  <span className="mr-15">Patent </span>
                  <span className={isPatent ? "green" : "red"}>
                    {isPatent ? "+" : "-"}
                  </span>
                </div>
              </Col>

              {techArray.map((elem, index) => (
                <Col className="flex  flex-align-center " key={index} style={{ paddingLeft: 0, paddingRight: 0 }}>
                  <div style={{ display: "none" }}>
                    <FloatLabel>
                      <Form.Item
                        name={["innovationCategories", elem, "id"]}
                        validateTrigger="onChange"
                      >
                        <InputText style={{borderRadius: "12px"}} size={"large"} className="w-full" id="id" />
                      </Form.Item>
                      <label htmlFor="id">{t("Texnologiyanın kateqoriyası")}</label>
                    </FloatLabel>
                  </div>
                  <Col md={6} sm={12} xs={24}>
                    <FloatLabel>

                      <Form.Item
                        name={[
                          "innovationCategories",
                          elem,
                          "technologyCategoryId",
                        ]}
                        validateTrigger="onChange"
                      >
                        <Select className="custom-select" onChange={(value) => getSubcategories(value, elem)} disabled={disable}>
                          {categories.map((p, index) => {
                            return (
                              <Option key={index} value={p.id}>
                                {p.name}
                              </Option>
                            );
                          })}
                        </Select>
                      </Form.Item>
                      <label htmlFor="technologyCategoryId">{t("Texnologiyanın kateqoriyası")}</label>
                    </FloatLabel>
                  </Col>

                  <Col md={6} sm={12} xs={24}>
                    <FloatLabel>
                      <Form.Item
                        name={[
                          "innovationCategories",
                          elem,
                          "technologySubcategoryId",
                        ]}
                        validateTrigger="onChange"
                      >
                        <Select className="custom-select"
                          onChange={(value) => getCategoriesType(value, elem)}
                          disabled={subDisable || props.view}
                        >
                          {subCategories?.map((item) => {
                            if (item.index === elem) {
                              return item.array.map((p, index) => {
                                return (
                                  <Option key={index} value={p.id}>
                                    {p.name}
                                  </Option>
                                );
                              });
                            }
                          })}
                        </Select>
                      </Form.Item>
                      <label htmlFor="technologySubcategoryId">{t("Alt kateqoriyası")}</label>
                    </FloatLabel>

                  </Col>
                  <Col md={6} sm={12} xs={24}>
                    <FloatLabel>
                      <Form.Item
                        name={["innovationCategories", elem, "technologyTypeId"]}
                        validateTrigger="onChange"
                      >
                        <Select className="custom-select" disabled={typeDisable || props.view}>
                          {categoriesType.map((item) => {
                            if (item.index === elem) {
                              return item.array.map((p, index) => {
                                return (
                                  <Option key={index} value={p.id}>
                                    {p.name}
                                  </Option>
                                );
                              });
                            }
                          })}
                        </Select>
                      </Form.Item>
                      <label htmlFor="technologyTypeId">{t("Növü")}</label>
                    </FloatLabel>
                  </Col>

                  {props.view ? "" :

                    <div>
                      <Button
                        onClick={() => setTechArray([...techArray, techArray[techArray.length - 1] + 1])}
                        className={"ml-15"}
                        type={"primary"}
                        shape={"circle"}
                        icon={<PlusOutlined />}
                      />
                      <Button
                        onClick={() => {
                          handleDeleteRow(elem);
                        }}
                        className={"ml-15"}
                        type={"primary"}
                        shape={"circle"}
                        icon={<MinusOutlined />}
                      />
                    </div>
                  }
                </Col>
              ))}
            </Row>
            {props.view ? "" :

              <div className="flex flex-end mb-20">
                <Button style={{borderRadius: "12px"}} onClick={cancelEditing}>{t("cancel")}</Button>

                <Button style={{borderRadius: "12px"}} type="primary" className="ml-10" htmlType="submit">
                  {t("save")}
                </Button>
              </div>
            }
          </Card>
        </div>
      </Form>
    </div>
  );
}

export default connect(null, { notify })(Innovation);
